import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Rrouter from "./Router/Router";

ReactDOM.render(
  <React.StrictMode>
    <Rrouter />
  </React.StrictMode>,
  document.getElementById("root")
);
